import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import debounce from 'lodash.debounce';
import Icon from 'react-fa';

import CrossChannelActions from '../actions/CrossChannelActions';
import { ScenarioParametersPropTypes } from '../util/helpers/SharedPropTypes';

function cloneScenario(organizationId, configs) {
  CrossChannelActions.cloneScenario(organizationId, configs);
}

function runSavedScenario(savedScenarioId) {
  CrossChannelActions.runSavedScenario(savedScenarioId)
    .catch((e) => {
      console.error(e);
    });
}

function debounceRunSavedScenario(savedScenarioId) {
  debounce(runSavedScenario(savedScenarioId), 10000);
}

function destroyScenario(savedScenarioId) {
  if (confirm('Are you absolutely sure you want to delete this saved scenario?')) {
    CrossChannelActions.destroyScenario(savedScenarioId)
      .catch((e) => {
        console.error(e);
      });
  }
}

const noLeftPadding = { paddingLeft: '0px', border: '0px' };

const ScenarioViewNavbar = ({ status, organizationId, configs, savedScenarioId }) => (
  <div className='scenario-navbar'>
    <Row>
      <Col sm={6}>
        <Button
          href='#/crosschannel'
          bsSize='large'
          className='cca-show-button'
          style={noLeftPadding}
        >
          <Icon name='caret-left' /> Go back
        </Button>
      </Col>
      <Col sm={6} className='text-right'>
        {
          (status === 'draft' || status === 'failed' || status === 'rejected') &&
          <Button
            href='#/crosschannel/'
            onClick={() => destroyScenario(savedScenarioId)}
            className='cca-show-button'
            bsStyle='danger'
          >
            Delete&nbsp;{ ' ' }<Icon name='trash' />
          </Button>
        }

        <Button
          href='#/crosschannel/new'
          onClick={() => cloneScenario(organizationId, configs)}
          className='cca-show-button'
          bsStyle='info'
        >
          Clone&nbsp;{ ' ' }<Icon name='clone' />
        </Button>

        {
          status === 'draft' &&
          <Button
            href='#/crosschannel/new/complete'
            onClick={() => debounceRunSavedScenario(savedScenarioId)}
            className='cca-show-button'
            bsStyle='primary'
          >
            Run&nbsp;{ ' ' }<Icon name='caret-right' />
          </Button>
        }
      </Col>
    </Row>
  </div>
);

ScenarioViewNavbar.propTypes = {
  status: PropTypes.string,
  organizationId: PropTypes.number,
  configs: ScenarioParametersPropTypes,
  savedScenarioId: PropTypes.number,
};

export default ScenarioViewNavbar;
